import { CLOSE_MESSAGE, OPEN_MESSAGE } from '../types/message'

const initState = {
  message: '',
  type: '',
  openMessage: false,
}

const messageReducer = (state = initState, action = {}) => {
  const { type, payload } = action

  switch (type) {
    case CLOSE_MESSAGE:
      return { ...initState }
    case OPEN_MESSAGE:
      return {
        ...state,
        ...payload,
        openMessage: true,
      }
    default:
      return state
  }
}

export default messageReducer



// WEBPACK FOOTER //
// ./src/reducers/message.js